/**
 * Runtime configuration published by /config.js, which index.html loads as a
 * classic script ahead of the module bundle.
 *
 * Every field is optional: the S3 + CloudFront deployment serves the empty
 * default from public/config.js, and readers fall back to the corresponding
 * build-time `VITE_*` value.
 */
export interface AppConfig {
  /** Origin the SPA sends API requests to, without a trailing slash. */
  baseApiUrl?: string;
  /** Commit SHA of the image serving this page; container deployments only. */
  imageTag?: string;
}

/**
 * Reads `window.__APP_CONFIG__` without a global `Window` interface merge.
 * That merge is only visible within the TypeScript program that includes its
 * declaring file, so every *other* project that imports this module — each
 * typechecked as its own isolated program — would not see the merge and
 * would fail with "Property '__APP_CONFIG__' does not exist on type
 * 'Window'". Asserting to a type that only adds an optional property is
 * always safe: every existing `Window` value already satisfies it, since an
 * optional property may be absent.
 */
export const getAppConfig = (): AppConfig | undefined =>
  (window as Window & { __APP_CONFIG__?: AppConfig }).__APP_CONFIG__;
